import { makeAutoObservable } from 'mobx';
import { token } from '@/infrastructure/container';
import { type ILocalStorage } from '@/services/LocalStorage';

const STORAGE_KEY = 'beforered:help-seen';

export class OnboardingStore {
  private _helpOpen = false;

  constructor(private storage: ILocalStorage) {
    makeAutoObservable(this);
    if (this.storage.get(STORAGE_KEY) !== '1') this._helpOpen = true;
  }

  get helpOpen(): boolean {
    return this._helpOpen;
  }

  openHelp = (): void => {
    this._helpOpen = true;
  };

  closeHelp = (): void => {
    this._helpOpen = false;
    this.storage.set(STORAGE_KEY, '1');
  };
}

export const TOKEN_OnboardingStore = token<OnboardingStore>('OnboardingStore');
